module.exports = __webpack_public_path__ + "img/pc_ewm.3c26adb7.png";